export default "__VITE_ASSET__CeFb3JiI__"